import { BaseCommand } from "@crunchdao/shared-cli";
import { StakingClient, formatCrunch } from "@crunchdao/sdk";

export class GetAvailableCommand extends BaseCommand {
  async execute(): Promise<void> {
    try {
      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
      });

      const available = await stakingClient.getAvailableAmountToStake();

      if (this.resolvedOptions.output === "json") {
        this.output({
          availableAmount: available.toString(),
          formatted: formatCrunch(available, 8),
        });
      } else {
        console.log(`\nAvailable to stake: ${formatCrunch(available, 8)} CRNCH`);
        console.log(`Raw amount: ${available.toString()}\n`);
      }
    } catch (error) {
      console.error("❌ Error getting available amount:", error);
      throw error;
    }
  }
}
